import moment from 'moment/moment';
import {
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // 组合单选、多选国家筛选器
  // COMPOSED_COUNTRY_SELECT as COMPOSED_COUNTRY_SELECT_FILTER,
  REGION as COUNTRY_REGION,
  // 单榜单筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  SINGLE_SOURCE_SELECT_EXTEND_TYPE,
  STORERANK_SEGEMENT,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { MarketSpecailType } from '@/pages/intelligence/hooks/useMarketSelector';

/**
 * 判断每一个date是否有效（配置的props名字disabledDate 语意刚好是相反的）
 * 这里是禁用当天以后的日期
 * @param date Moment日期对象
 * @return 当前date是否有效
 */
const isValidDate = (date: moment.Moment): boolean => {
  if (!date?.isValid()) return true;
  return date?.isSameOrBefore(moment(), 'day');
};

// 静态筛选器配置，即所有配置相关的都是常量，不需要通过组件props、组件其他state、组件其他变量来决定 可以单独写在一个js文件中
export const STATIC_FILTER_CONFIGS = {
  SEGMENT_STORERANK: {
    key: STORERANK_SEGEMENT,
    type: STORERANK_SEGEMENT,
    default: 'rank',
    value: '',
  },
  RANGE_TIME_SELECT_FILTER: {
    key: RANGE_TIME_SELECT_FILTER,
    type: RANGE_TIME_SELECT_FILTER,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    showSelectType: false,
    showShortcut: true,
    startOfWeek: 1,
    hiddenHeaderBtns: ['Latest Data', 'All of time'],
  },
  // COMPOSED_COUNTRY_SELECT_FILTER: {
  //   key: COMPOSED_COUNTRY_SELECT_FILTER,
  //   type: COMPOSED_COUNTRY_SELECT_FILTER,
  //   visible: 1,
  //   disabled: false,
  //   isAll: false,
  //   defaultSingleCountry: 'cn',
  // },
  COUNTRY_REGION_FILTER: {
    extendFilterType: MarketSpecailType.common,
    key: COUNTRY_REGION,
    type: COUNTRY_REGION,
  },
  SINGLE_SOURCE_SELECT_FILTER: {
    key: SINGLE_SOURCE_SELECT_FILTER,
    type: SINGLE_SOURCE_SELECT_FILTER,
    extendFilterType: SINGLE_SOURCE_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    sources: [],
  },
};

// 各个筛选器组件UI渲染需要的value
export const DEFAULT_FORM_VALUE = {
  [STORERANK_SEGEMENT]: {
    value: 'rank',
  },
  [RANGE_TIME_SELECT_FILTER]: {
    type: 'date',
    value: ['', ''],
  },
  // [COMPOSED_COUNTRY_SELECT_FILTER]: {
  //   value: {
  //     type: 'multiple',
  //     countries: ['us'],
  //   },
  // },
  [COUNTRY_REGION]: {
    markets: ['global'],
    type: 'market',
    regions: [],
  },
  [SINGLE_SOURCE_SELECT_FILTER]: {
    value: 'appstore top free',
  },
};
